export function oxgGetLang() {
  const documentLanguage = document.documentElement.lang;
  const navigatorLanguage = navigator.language || navigator.userLanguage;
  return documentLanguage || navigatorLanguage;
}

export function oxgLangDeOrEn(lang) {
  if( ['de-DE', 'de', 'de-AT', 'de-CH', 'de-LI', 'de-LU'].includes(lang) ) {
    return 'de'
  } else if ( ['en-US', 'en-GB', 'en-AU', 'en-CA', 'en-IN', 'en-IE', 'en-NZ', 'en-ZA', 'en-PH', 'en-SG', 'en-NG', 'en-PK', 'en-JM'].includes(lang) ) {
    return 'en'
  } else {
    return null
  }
}

export function oxgLangIsGerman(lang) {
  if( ['de-DE', 'de', 'de-AT', 'de-CH', 'de-LI', 'de-LU'].includes(lang) ) {
    return true
  } else {
    return false
  }
}

export function oxgLangIsEnglish(lang) {
  if( ['en-US', 'en-GB'].includes(lang) ) {
    return true
  } else {
    return false
  }
}